export default "__VITE_ASSET__22ckdakK__"